export default {
  app: {
    languagePopup: {
      title: '現在、{logo}の英語版をご利用中です',
      subtitle: 'ご希望の言語に切り替えますか？',
      cta: '{lang} に切り替える',
    },
  },
};
